export default __webpack_public_path__ + "static/media/Payment History.ad83b47b.svg";